import { frontendURL } from 'dashboard/helper/URLHelper';
import DealsBoard from './pages/DealsBoard.vue';
import PipelineReport from './pages/PipelineReport.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'wasapi_crm_board',
    component: DealsBoard,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/crm/pipelines/:pipelineId/report'),
    name: 'wasapi_crm_report',
    component: PipelineReport,
    meta: { permissions: ['administrator'] },
  },
];
